import { Suspense, useEffect } from 'react';
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import { Route, Switch, useHistory, useLocation, withRouter } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import './vendor/datatables/css/dataTables.min.css';
import "./css/style.css";
import Login from './jsx/page/Auth/Login';

const langOption = [
    { name: 'English', code: 'en' },
    { name: '中文 (简体)', code: 'zh_cn' },
]

function App(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        let language = localStorage.getItem('rsi-admin-lang');
        if (language) {
            if (langOption.filter(item => item.code === language).length > 0) {
                dispatch({
                    type: "UPDATE_LANGUAGE",
                    lang: language,
                });
            } else {
                dispatch({
                    type: "UPDATE_LANGUAGE",
                    lang: 'zh_cn',
                });
            }
        } else {
            dispatch({
                type: "UPDATE_LANGUAGE",
                lang: 'zh_cn',
            });
        }
        checkAutoLogin(dispatch, props.history, location.pathname);
    }, [dispatch, props.history, location.pathname]);


    useEffect(() => {
        history.listen((location) => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
        });
    }, [history]);

    let routes = (
        <Switch>
            <Route path='/' component={Login} />
            <Route path='/login' component={Login} />
        </Switch>
    );
    if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    <Index />
                </Suspense>
            </>
        );

    } else {
        return (
            <div className="vh-100">
                {routes}
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App));

